import React, {useEffect, useRef} from "react";
import {Terminal} from "xterm";
import {FitAddon} from "xterm-addon-fit";
import {useSize} from "ahooks";
import TerminalColor from "./terminal-color";
import styles from "./index.module.less";

const EditorTerminal = ({ height, stdout, stderr, message }) => {
  const terminal = useRef(new Terminal({
    disableStdin: false,
    convertEol: true
  }));
  const terminalEl = useRef();
  const terminalFitAddon = useRef(new FitAddon());
  const terminalSize = useSize(terminalEl);
  useEffect(() => {
    terminal.current.loadAddon(terminalFitAddon.current);
    terminal.current.open(terminalEl.current);
    terminalFitAddon.current.fit();
  }, []);
  useEffect(() => {
    terminalFitAddon.current.fit();
  }, [terminalSize]);
  useEffect(() => {
    if (message) {
      terminalWriteLine(message, TerminalColor.GREEN);
    }
    if (stdout) {
      terminalWriteLine(stdout, TerminalColor.WHITE);
    }else if (stderr) {
      terminalWriteLine(stderr, TerminalColor.RED);
    }
  }, [stdout, stderr]);
  const terminalWriteLine = (line, color = TerminalColor.WHITE, clean = false) => {
    if (clean === true) {
      terminal.current.clear();
    }
    terminal.current.writeln(`${color}${line}`);
  };
  return (
    <div className={styles.terminal} ref={terminalEl} style={{ height }} />
  );
};

export default EditorTerminal;
